import { render, staticRenderFns } from "./edit-brand.vue?vue&type=template&id=2845666c&scoped=true"
import script from "./edit-brand.vue?vue&type=script&lang=js"
export * from "./edit-brand.vue?vue&type=script&lang=js"
import style0 from "./edit-brand.vue?vue&type=style&index=0&id=2845666c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845666c",
  null
  
)

export default component.exports